// extracted by mini-css-extract-plugin
module.exports = {"reviewSelectionContainer":"ReviewSelectionModal_reviewSelectionContainer__1m9i6","infoIcon":"ReviewSelectionModal_infoIcon__IEH37"};